import { cacheKeys } from "@constants/cache-keys";
import { PointsBasedTagsDetailView } from "@features/dashboard/components/Progress/PointsBasedTagsDetailView";
import { useExamContext } from "@features/exam/contexts/ExamContext";
import { useAppStore } from "@hooks/useAppStore";
import useClerkUser from "@hooks/useClerkUser";
import type { MixedItemDist } from "@memorang/types/src/tag";
import { useQueryClient } from "@tanstack/react-query";
import TopicsDetailView from "components/Topics/TopicsDetailView";
import { useLocalSearchParams } from "expo-router";

const DetailedListMasteryContainer = () => {
	const { type } = useLocalSearchParams<{
		type: string;
	}>();

	const { userLogicalId } = useClerkUser();

	const {
		currentExamContext: { studyPackCollectionId },
	} = useExamContext();

	const queryClient = useQueryClient();
	const showPointsBasedScore = useAppStore(
		(state) => state.reportView?.formative?.showPointsBasedScore,
	);
	const mixedItemDistResponse = queryClient.getQueryData<MixedItemDist>([
		cacheKeys.home,
		userLogicalId,
		"COMMON_DISTRIBUTION",
		studyPackCollectionId,
	]);

	if (!mixedItemDistResponse) {
		return null;
	}

	const { tags } = mixedItemDistResponse;

	if (showPointsBasedScore) {
		return <PointsBasedTagsDetailView title={type!} tags={tags} />;
	}

	return <TopicsDetailView tags={tags} type={type} />;
};

export default DetailedListMasteryContainer;
